const initialState = {
    loaded: false,
    list: []
}

const contractsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CONTRACTS':
            return {
                ...state,
                list: action.contracts
            }
        case 'CONTRACTS_LOADED':
            return {
                ...state,
                list: state.list,
                loaded: action.loaded
            }
        case 'SELECT_CONTRACT':
            return {
                ...state,
                selected: action.contract
            }
        case 'NEW_CONTRACT':
            return {
                ...state,
                created: action.created
            }
        case 'CURRENT_CONTRACT_UPDATED':
            return {
                ...state,
                updated: action.updated
            }
        case 'CONTRACTS_REQUEST': {
            return {
                ...state,
                error: action.error,
                message: action.message
            }
        }
        default:
            return state
    }
}

export default contractsReducer


// WEBPACK FOOTER //
// ./src/components/Contracts/ContractsReducers.js